import React from 'react';
import { StyleSheet, Pressable } from 'react-native';
import { Link as RouterLink } from 'expo-router';
import Text from '@/components/Typography/Text';

const styles = StyleSheet.create({
  link: {
    alignSelf: 'flex-start',
  },
  text: {
    textDecorationLine: 'none',
  },
}); 

export default function Link({ 
  children, 
  href,
  onPress, 
  isDisabled = false,
  ...props 
}) {
  return (
    <RouterLink href={href} asChild>
      <Pressable 
        disabled={isDisabled}
        style={styles.link}
        {...props}
      >
        <Text
          weight='medium'
          color={!!isDisabled ? 'tertiary' : 'primary'}
          style={styles.text}
        >
          {children}
        </Text>
      </Pressable>
    </RouterLink>
  );
}